import { label, labelSecondary } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  root: {
    padding: '0',
    width: 'auto',

    // Each country
    '& > div:first-child': {
      background: labelSecondary,
      boxShadow: 'none',
      borderBottom: `1px solid ${label}`,
      borderRadius: '0',
    },

    // Last country
    '&:last-child > div:first-child': {
      borderBottom: 'none',
      borderBottomLeftRadius: '0.7rem',
      borderBottomRightRadius: '0.7rem',
    },
  },
})
